export default class Locale_Schedules { 
	Schedule: string = "Schedule";
	SchedulesDeleted: string = "Schedules deleted";
	SchedulesSaved: string = "Schedules saved";
	GettingSchedulesForTeamPlanner: string = "Getting schedules for TeamPlanner.";
	SavingSchedule: string = "Saving schedule..";	
	FailedToSaveSchedule: string = "Failed to save schedule..";
	SaveScheduleSuccessfullyCompleted: string = "Save schedule succesfully completed..";
}